import styles from "./styles.module.scss";

function EverythingYouNeed() {
  return (
    <section className={styles["everything-you-need-section"]}>
      <h2 className={`text:heading-2 ${styles["everything-title"]}`}>
        Kikoff Secured Credit Card has <br />
        everything you need
      </h2>
      <ol className={styles["everything-list"]}>
        <li className={`text:heading-4 ${styles["everything-item"]}`}>
          FDIC insured up to $250,000 through Coastal Community Bank, Member
          FDIC
        </li>
        <li className={`text:heading-4 ${styles["everything-item"]}`}>
          Mastercard® Zero Liability Protection<sup>7</sup>
        </li>
        <li className={`text:heading-4 ${styles["everything-item"]}`}>
          State-of-the-art security and privacy
        </li>
      </ol>
    </section>
  );
}

export default EverythingYouNeed;
